export interface TrackingState {
  /** UUID per browser tab/session — equivalent to a GA session.
   * Created lazily on first use; null on the server. */
  sessionId: string | null;
}

export const initialTrackingState: TrackingState = {
  sessionId: null,
};
